/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";

import { ec as EC } from "elliptic";
import { toast } from "react-hot-toast";
import { UserAuth } from "../context/authContext";
// import { FaRegClipboard } from "react-icons/fa";
import { serverTimestamp } from "firebase/firestore";
import { db } from "../config/firebaseConfig";
import CopyComponent from "./utils/CopyComponent";
import FirestoreTimestampToDate from "./utils/FirebaseTimetoDate";

const MemPool=() => {
  //   const { id } = useParams();
  const [roomId, setRoomId]=useState(localStorage.getItem("roomId")||"");
  const { userData }=UserAuth();
  const [hasAddedTransactions, setHasAddedTransactions]=useState(false);
  const [transactions, setTransactions]=useState([]);

  const generatePublicKeyFromPrivate=(privateKey) => {
    const ec=new EC("secp256k1");
    const keyPair=ec.keyFromPrivate(privateKey.slice(2), "hex");
    return "0x"+keyPair.getPublic(false, "hex").slice(2);
  };

  // Function to verify the sender's private key using the sender's public key
  const verifyPrivateKey=(senderPrivateKey, senderPublicKey) => {
    const generatedSenderPublicKey=
      generatePublicKeyFromPrivate(senderPrivateKey);
    return generatedSenderPublicKey===senderPublicKey;
  };

  const verifyTransaction=async (transaction) => {
    if (!roomId) return;

    try {
      const signature=transaction.signature;
      const matchResult=signature.match(/0x[a-fA-F0-9]{64}/g);

      // Extract the components
      const [receiverPublicKey, senderPrivateKey]=matchResult;

      const senderPublicKey=prompt(
        "Enter the sender's public key to verify the transaction, in order to verify the transaction signature using RSA.(Senders public key is required to verify the transaction signature)",
      );
      if (!senderPublicKey) {
        toast.error(
          "Sender's public key is required to verify the transaction",
        );
        return;
      }

      const isValidPrivateKey=verifyPrivateKey(
        senderPrivateKey,
        senderPublicKey,
      );

      if (!isValidPrivateKey) {
        toast.error("Invalid sender's publick key");
        return;
      } else {
        // Update transaction verfied status by miner publicKey
        const res=await db
          .collection("rooms")
          .doc(roomId)
          .collection("transactions")
          .doc(transaction.id)
          .update({
            minerPublicKey: userData.publicKey,
            status: "Validate",
            verified: true,
          });
        toast.success("Sender's private key verified successfully");
      }
      fetchRoomTransactions();
    } catch (e) {
      console.error("Failed to vote:", e.message);
      toast.error("Failed to vote");
    }
  };

  const validateTransaction=async (transaction) => {
    if (!roomId) return;

    // check the users balance first
    const senderRef=db.collection("users").doc(transaction.senderEmail);
    const userSnapshot=await senderRef.get();
    const senderData=userSnapshot.data();
    if (!senderData) {
      toast.error("Sender not found");
      return;
    }

    // check if the miner is the verifier
    if (userData.publicKey!==transaction.minerPublicKey) {
      toast.error("You are not the verifier of this transaction");
      return;
    }

    try {
      // check the user balance and request transaction amount
      if (senderData.balance<transaction.amount) {
        toast.error("Insufficient balance");
        // update the transaction collection with the status of the transaction
        const res=await db
          .collection("rooms")
          .doc(roomId)
          .collection("transactions")
          .doc(transaction.id)
          .update({
            status: "failed",
            failedMessage: "Insufficient balance",
            validatedAt: serverTimestamp(),
          });
      } else {
        // update the transaction collection with the status of the transaction
        const res=await db
          .collection("rooms")
          .doc(roomId)
          .collection("transactions")
          .doc(transaction.id)
          .update({
            status: "Add to block",
            validatedAt: serverTimestamp(),
          });
        // deduct the sender's balance
        const newBalance=senderData.balance-transaction.amount;
        await senderRef.update({
          balance: newBalance,
        });
        toast.success("Validation successful!");
      }
    } catch (e) {
      console.error("Failed to vote:", e.message);
      toast.error("Failed to vote");
    }
  };

  const addTransactionToBlock=async (transaction) => {
    if (!roomId) return;
    // check transaction is verified or not
    if (!transaction.verified) {
      toast.error("Transaction not verified");
      return;
    }

    // check if transaction is status is pending
    if (transaction.status==="Validate") {
      toast.error(
        "Transaction is pending, first verify and validate the transaction",
      );
      return;
    }

    // check if transaction is status is failed
    if (transaction.status==="failed") {
      toast.error("Transaction is failed, cannot be added");
      return;
    }

    // check if transaction is already added to block
    if (transaction.blockStatus==="added") {
      toast.error("Transaction already added to block");
      return;
    }

    // check if the miner is the verifier of the transaction
    if (transaction.minerPublicKey!==userData.publicKey) {
      toast.error("You are not the verifier of this transaction");
      return;
    }

    try {
      // check for empty block collection
      const res=await db
        .collection("rooms")
        .doc(roomId)
        .collection("transactions")
        .doc(transaction.id)
        .update({
          blockStatus: "added",
          status: "Added to block",
          addedAt: serverTimestamp(),
        });
      toast.success("Transaction added to block successfully");
    } catch (e) {
      console.error("Failed to add transaction to block:", e.message);
      toast.error("Failed to add transaction to block");
    }
  };

  const updateActionState=(transaction) => {
    switch (transaction.status) {
      case "Verify":
        verifyTransaction(transaction);
        break;
      case "Validate":
        validateTransaction(transaction);
        break;
      case "Add to block":
        addTransactionToBlock(transaction);
        break;
    }
    fetchRoomTransactions();
  };

  const fetchRoomTransactions=async () => {
    if (!roomId) return;

    try {
      const roomRef = db.collection("rooms").doc(roomId);
      roomRef.collection("transactions").orderBy("timestamp", "desc").onSnapshot((snapshot) => {
        const data = [];
        snapshot.forEach((t) => {
          data.push({ id: t.id, ...t.data() });
        });
        setTransactions(data);
        const allAdded=data.every(
          (t) => t.status==="Added to block"||t.status==="Added to chain",
        );
        setHasAddedTransactions(allAdded);
      });
    } catch (error) {
      console.error("Error fetching room transactions:", error);
      toast.error("Error fetching room transactions.");
    }
  };

  useEffect(() => {
    if (roomId) fetchRoomTransactions();
  }, [roomId]);

  return (
    <div className="min-h-screen pt-10">
      {/* Header */}
      <div className="max-w-[88vw] mx-auto mb-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-white">
            MemPool for: <span className="text-[#6C4FFF]">{roomId}</span>
          </h2>
          <a
            href="/blocks"
            className="px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5840D9] text-white rounded-lg hover:opacity-90 transition font-medium"
          >
            My Blocks
          </a>
        </div>

        {/* Transactions Table */}
        <div className="bg-[#343B4F] rounded-lg overflow-hidden">
          {transactions.filter(
            (transaction) =>
              transaction.status !== "genisis" &&
              transaction.status !== "Added to chain" &&
              transaction.status !== "Added to block",
          ).length >= 1 ? (
            <div className="max-h-[70vh] overflow-y-auto overflow-x-hidden custom-scrollbar">
              <table className="w-full table-fixed">
                <colgroup>
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "5%" }} />
                </colgroup>
                <thead>
                  <tr className="border-b border-[#1B1E3E]">
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Tx Hash
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Sender
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Receiver
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Signature
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Timestamp
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Amount
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Status
                    </th>
                    <th className="text-left py-3 px-2 text-gray-300 font-semibold text-xs">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {transactions
                    .filter(
                      (transaction) =>
                        transaction.status!=="genisis"&&
                        transaction.status!=="Added to chain"&&
                        transaction.status!=="Added to block",
                    )
                    .map((transaction) => (
                      <tr
                        key={transaction.id}
                        className="border-b border-[#1B1E3E] hover:bg-[#2a3347] transition"
                      >
                        <td className="py-3 px-2 overflow-hidden">
                          <CopyComponent data={transaction.hash} />
                        </td>
                        <td className="py-3 px-2 overflow-hidden">
                          <CopyComponent data={transaction.sender} />
                        </td>
                        <td className="py-3 px-2 overflow-hidden">
                          <CopyComponent data={transaction.receiver} />
                        </td>
                        <td className="py-3 px-2 overflow-hidden">
                          <CopyComponent data={transaction.signature} />
                        </td>
                        <td className="py-3 px-2 text-gray-300 text-xs whitespace-nowrap">
                          {FirestoreTimestampToDate(transaction.timestamp)}
                        </td>
                        <td className="py-3 px-2 text-white font-semibold text-xs">
                          {transaction.amount}
                        </td>
                        <td className="py-3 px-2">
                          <span
                            className={`px-3 py-1 rounded-full text-xs font-medium ${transaction.status=="Verify"
                              ? "bg-red-500/20 text-red-400"
                              :transaction.status=="Validate"
                                ? "bg-yellow-500/20 text-yellow-400"
                                :"bg-green-500/20 text-green-400"
                              }`}
                          >
                            {transaction.status=="Verify"
                              ? "Not Verified"
                              :transaction.status=="Validate"
                                ? "Verified"
                                :"Validated"}
                          </span>
                        </td>
                        <td className="py-3 px-2">
                          {transaction.status !== "Added to block" ? (
                            <button
                              onClick={() => updateActionState(transaction)}
                              className="px-2 py-1 bg-gradient-to-r from-[#6C4FFF] to-[#5840D9] text-white rounded-lg hover:opacity-90 transition text-xs font-medium whitespace-nowrap"
                            >
                              {transaction.status}
                            </button>
                          ) : (
                            <div className="px-2 py-1 bg-green-500/20 text-green-400 rounded-lg text-xs font-medium text-center whitespace-nowrap">
                              {transaction.status}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ):(
            <div className="py-16 text-center">
              <p className="text-gray-400 text-lg">
                No pending transactions in the mempool
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemPool;
